import { useState } from 'react';
import { Outlet, NavLink, Link } from 'react-router-dom';
import {
  LayoutDashboard, ShoppingBag, PlusCircle,
  ShoppingCart, MessageCircle, MoreHorizontal,
  User, Search, Info, Download, X, Shield, Bell,
} from 'lucide-react';
import Navbar  from './Navbar';
import Sidebar from './Sidebar';
import { useSocket } from '../../context/SocketContext';
import { useAuth } from '../../context/AuthContext';
import './AppLayout.css';

export default function AppLayout() {
  return (
    <div className="app-shell">
      <Navbar />
      <div className="app-body">
        <Sidebar />
        <main className="app-main">
          <div className="app-content">
            <Outlet />
          </div>
        </main>
      </div>
      <BottomBar />
    </div>
  );
}

function BottomBar() {
  const { unreadChats } = useSocket();
  const { isAdmin }     = useAuth();
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      {/* More drawer overlay */}
      {showMore && (
        <div className="bottom-more-overlay" onClick={() => setShowMore(false)}>
          <div className="bottom-more-menu" onClick={(e) => e.stopPropagation()}>
            <div className="bottom-more-header">
              <span>More</span>
              <button className="bottom-more-close" onClick={() => setShowMore(false)}>
                <X size={18} />
              </button>
            </div>

            <NavLink to="/app/chat"
              className={({ isActive }) => 'bottom-more-item ' + (isActive ? 'active' : '')}
              onClick={() => setShowMore(false)}>
              <div style={{ position: 'relative', display: 'inline-flex' }}>
                <MessageCircle size={20} />
                {unreadChats > 0 && (
                  <span className="bottom-tab-badge">{unreadChats > 9 ? '9+' : unreadChats}</span>
                )}
              </div>
              <span>Messages</span>
            </NavLink>

            <NavLink to="/app/profile"
              className={({ isActive }) => 'bottom-more-item ' + (isActive ? 'active' : '')}
              onClick={() => setShowMore(false)}>
              <User size={20} />
              <span>Profile</span>
            </NavLink>

            <NavLink to="/app/lostfound"
              className={({ isActive }) => 'bottom-more-item ' + (isActive ? 'active' : '')}
              onClick={() => setShowMore(false)}>
              <Search size={20} />
              <span>Lost &amp; Found</span>
            </NavLink>

            {isAdmin && (
              <NavLink to="/admin"
                className={({ isActive }) => 'bottom-more-item ' + (isActive ? 'active' : '')}
                onClick={() => setShowMore(false)}>
                <Shield size={20} />
                <span>Admin Portal</span>
              </NavLink>
            )}

            <NavLink to="/app/install"
              className={({ isActive }) => 'bottom-more-item ' + (isActive ? 'active' : '')}
              onClick={() => setShowMore(false)}>
              <Download size={20} />
              <span>Install App</span>
            </NavLink>

            <NavLink to="/app/about"
              className={({ isActive }) => 'bottom-more-item ' + (isActive ? 'active' : '')}
              onClick={() => setShowMore(false)}>
              <Info size={20} />
              <span>About</span>
            </NavLink>
          </div>
        </div>
      )}

      {/* ── Bottom tab bar: Home · Market · Sell · Cart · More ── */}
      <nav className="bottom-bar">
        <NavLink to="/app/dashboard"
          className={({ isActive }) => 'bottom-tab ' + (isActive ? 'active' : '')}>
          <LayoutDashboard size={20} />
          <span>Home</span>
        </NavLink>

        <NavLink to="/app/marketplace"
          className={({ isActive }) => 'bottom-tab ' + (isActive ? 'active' : '')}>
          <ShoppingBag size={20} />
          <span>Market</span>
        </NavLink>

        {/* Sell — centre elevated button */}
        <NavLink to="/app/sell" className="bottom-tab bottom-tab-sell">
          <PlusCircle size={22} />
          <span>Sell</span>
        </NavLink>

        <NavLink to="/app/cart"
          className={({ isActive }) => 'bottom-tab ' + (isActive ? 'active' : '')}>
          <ShoppingCart size={20} />
          <span>Cart</span>
        </NavLink>

        <button
          className={'bottom-tab ' + (showMore ? 'active' : '')}
          onClick={() => setShowMore((s) => !s)}
        >
          <MoreHorizontal size={20} />
          <span>More</span>
        </button>
      </nav>
    </>
  );
}